import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Observable";
import { PointBalance } from "../../models/point-balance";
import { Api } from "../api/api";
import { AlertController } from "ionic-angular";
import {
  PointHistory,
  DISTRIBUTION_IOS,
  DISTRIBUTION_ANDROID,
} from "../../models/point-history";

interface TransactionDataForPoint {
  transaction_id: string;
  product_id: string;
  price_str: string;
  currency: string;
  receipt_data: string;
  signature: string;
  product_type: string;
}

@Injectable()
export class PointProvider {
  private url: string = "points";
  constructor(
    public http: HttpClient,
    public api: Api,
    public alertCtrl: AlertController
  ) {}

  fetchPoint(): Observable<PointBalance> {
    return this.api.get(this.url);
  }

  // /api/v1/points/history
  fetchHistory(page: number): Observable<PointHistory[]> {
    return this.api
      .get(this.url + "/history", false, { page: page })
      .map((histories) => histories.map((room) => new PointHistory(room)));
  }

  // PUT/PATCH /api/v1/points
  buy(transactionData: TransactionDataForPoint) {
    return this.api.post(this.url, {
      transaction: transactionData,
    });
  }

  // POST /api/v1/points/daily
  daily() {
    return this.api.post(this.url + "/daily", {});
  }

  arrangePoint(currentDevice: number, pointBalance: PointBalance): number {
    let balance: number = 0;
    balance = pointBalance.free_point;
    if (currentDevice === DISTRIBUTION_IOS) {
      balance += pointBalance.ios_point;
      balance += pointBalance.android_point;
      balance += pointBalance.web_point;
    } else if (currentDevice === DISTRIBUTION_ANDROID) {
      balance += pointBalance.android_point;
    } else {
      balance += pointBalance.web_point;
    }
    return balance;
  }

  restore(
    productId: string,
    state: string,
    price: string,
    currency: string,
    transactionId: string,
    currentDate: string,
    productType: string,
    receiptData: string,
    signature: string
  ): Observable<any> {
    return this.api.post("/" + this.url + "/restore", {
      product_id: productId,
      state: state,
      price_str: price,
      currency: currency,
      transaction_id: transactionId,
      current_date: currentDate,
      product_type: productType,
      receipt_data: receiptData,
      signature: signature,
    });
  }

  usePoint(
    userId: number,
    point: number,
    purpose: string,
    toUserId: number
  ): Observable<any> {
    return this.api.post(this.url + "/use_points", {
      user_id: userId,
      amount: point,
      purpose: purpose,
      to_user_id: toUserId,
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/point/point.ts